import BOX_TYPE from 'config/constants/boxTypes';
import { Service, Industry, Region, ProductStage } from './enums.js';

export const BLOGS = [
  {
    type: BOX_TYPE.BLOG,
    title: 'Introducing Data Visualization in D3 JavaScript library',
    content: {
      industry: [''],
      service: [Service.PDD],
      productStage: [''],
      region: [''],
    },
    settings: {},
    id: 'box-data-visualisation-JS',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Marble.js – new open source framework for JavaScript',
    content: {
      industry: [Industry.SAAS, Industry.ITServices],
      service: [Service.PDD],
      productStage: [''],
      region: [Region.Europe, Region.NorthAmerica],
    },
    settings: {},
    id: 'box-marblejs',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Digitalizing renewable energy',
    content: {
      industry: [Industry.Energy],
      service: [Service.DigitalTransformation, Service.MachineLearning],
      productStage: [''],
      region: [''],
    },
    settings: {},
    id: 'box-renewable-energy',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'System Story – the little sentence that builds big things',
    content: {
      industry: [''],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.Prototype],
      region: [''],
    },
    settings: {},
    id: 'box-system-story',
  },
  {
    type: BOX_TYPE.BLOG,
    title:
      'Predictive maintenance for wind turbines - an interview with Boldare’s machine learning engineers',
    content: {
      industry: [Industry.Energy],
      service: [''],
      productStage: [ProductStage.Prototype],
      region: [''],
    },
    settings: {},
    id: 'box-predictive-maintenance',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Lean process for a better product',
    content: {
      industry: [Industry.Energy, Industry.Media],
      service: [Service.FCPD],
      productStage: [ProductStage.MVP, ProductStage.Scaling],
      region: [Region.MiddleEastAndAfrica],
    },
    settings: {},
    id: 'box-lean-process',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'A step by step guide to Event Storming – our experience',
    content: {
      industry: [Industry.Travel],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.Prototype, ProductStage.PMF],
      region: [''],
    },
    settings: {},
    id: 'box-event-storming',
  },
  {
    type: BOX_TYPE.BLOG,
    title:
      'Building digital products based on machine learning - the cost perspective',
    content: {
      industry: [Industry.Energy, Industry.Travel, Industry.SAAS],
      service: [Service.MachineLearning],
      productStage: [''],
      region: [Region.Europe],
    },
    settings: {},
    id: 'box-building-products-ML',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'What are design sprints?',
    content: {
      industry: [''],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.Prototype],
      region: [Region.MiddleEastAndAfrica, Region.Asia],
    },
    settings: {},
    id: 'box-design-sprints',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'How machine learning is boosting businesses',
    content: {
      industry: [Industry.Energy, Industry.ECommerce],
      service: [Service.MachineLearning],
      productStage: [''],
      region: [''],
    },
    settings: {},
    id: 'box-ML-boosting-business',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Scaling Your Product – thriving in the market',
    content: {
      industry: [Industry.ECommerce, Industry.Travel],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.Scaling],
      region: [Region.Europe, Region.MiddleEastAndAfrica],
    },
    settings: {},
    id: 'box-scaling-product',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Wondering about viability? Let impact mapping reassure you',
    content: {
      industry: [Industry.Media, Industry.ECommerce],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.PMF],
      region: [''],
    },
    settings: {},
    id: 'box-impact-mapping',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'How to start a neural network with JavaScript in 5 minutes',
    content: {
      industry: [''],
      service: [Service.MachineLearning],
      productStage: [''],
      region: [''],
    },
    settings: {},
    id: 'box-neural-network-JS',
  },
  {
    type: BOX_TYPE.BLOG,
    title:
      'This is how Boldare Development Teams process addresses your business needs',
    content: {
      industry: [''],
      service: [
        Service.PDD,
        Service.FCPD,
        Service.DevTeam,
        Service.DigitalTransformation,
      ],
      productStage: [''],
      region: [''],
    },
    settings: {},
    id: 'box-digital-products-Bldr',
  },
  {
    type: BOX_TYPE.BLOG,
    title: '6 benefits from having a QA/BA in your development team',
    content: {
      industry: [Industry.Travel],
      service: [Service.PDD, Service.DevTeam],
      productStage: [ProductStage.PMF],
      region: [''],
    },
    settings: {},
    id: 'box-benefits-qa-ba',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'MVP development - what, why and how?',
    content: {
      industry: [Industry.Media],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.MVP],
      region: [Region.MiddleEastAndAfrica, Region.NorthAmerica],
    },
    settings: {},
    id: 'box-what-why-how-MVP',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Effective scaling through teamwork',
    content: {
      industry: [''],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.Scaling],
      region: [''],
    },
    settings: {},
    id: 'box-effective-scaling',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'What is Design Thinking?',
    content: {
      industry: [''],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.Prototype],
      region: [Region.Asia],
    },
    settings: {},
    id: 'box-what-is-design-thinking',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Product Vision Workshops – seeing clearly from the beginning',
    content: {
      industry: [Industry.SAAS, Industry.ITServices],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.MVP, ProductStage.Scaling],
      region: [''],
    },
    settings: {},
    id: 'box-product-vision-workshops',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Product-Market Fit – teamworking for results',
    content: {
      industry: [Industry.ITServices],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.PMF],
      region: [Region.NorthAmerica],
    },
    settings: {},
    id: 'box-product-marketfit',
  },
  {
    type: BOX_TYPE.BLOG,
    title: 'Digital Product Prototyping – what’s it all about?',
    content: {
      industry: [''],
      service: [Service.PDD, Service.FCPD, Service.DevTeam],
      productStage: [ProductStage.Prototype],
      region: [''],
    },
    settings: {},
    id: 'box-digital-product-prototyping',
  },
];
